import { ReactSVG } from 'react-svg'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface LoaderCircleProps {
  className?: string;
}

export default function LoaderCircle (props: LoaderCircleProps) {
  const { className } = props

  return (
    <ReactSVG
      className={cn(styles.root, className)}
      src="/icons/loader.svg"
      wrapper="span"
    />
  )
}
